import cleanedFilename from '~/util/cleanedFilename';

export default {
  START_CONDITION_CONTAINER: `${cleanedFilename(
    __filename,
  )}-start-condition-container`,
};
